import axios from "axios";
import { User } from "../types";
import jwtDecode from "jwt-decode";

const TOKEN_KEY = "token";
const defaultUser: User = {
    mail: "",
    token: "",
    nombre: "",
    isAuthenticated: false
}

const setToken = (token: string) => {
    localStorage.setItem(TOKEN_KEY, token);
}
const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
}

const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
}
const removeRoutes = () => {
    localStorage.removeItem('React.LC.KY.MS');
}

const removeLocalVars = () => {
    sessionStorage.removeItem('item');
    sessionStorage.removeItem('title');
}


export const authenticate = (token?: string): User => {
    if (token) {
        setToken(token)
    }
    const _token = token ? token : getToken();

    if (!_token) {
        return { ...defaultUser };
    }
    const decoded: any = jwtDecode(_token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        removeToken();
        removeLocalVars();
        removeRoutes();
        delete axios.defaults.headers.common["Authorization"];

        // Redirige al usuario a la página de inicio de sesión cuando el token ha expirado
        window.location.href = "/login";
        return { ...defaultUser };
    }

    axios.defaults.headers.common["Authorization"] = _token;

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 403) {
                // Mostrar alerta genérica

                if (decoded.exp < (Date.now() / 1000)) {
                    alert('Session Vencida, iniciar sesion...');
                    logout()

                    // Redirige al usuario a la página de inicio de sesión cuando el token ha expirado
                    window.location.href = "/login";
                }//else {
                   // alert('Acceso denegado');

              //  }

            }
            return Promise.reject(error);
        }
    );

    return { ...defaultUser, mail: decoded.sub, isAuthenticated: true, token: _token };

}

export const logout = (): User => {
    removeLocalVars();
    removeToken();
    removeRoutes();
    //elimina token de axios
    delete axios.defaults.headers.common["Authorization"];
    return { ...defaultUser };

}



